const EXPLORE_ACTIONS = ['explore:viewPage', 'explore:download'];

const EXPLORE_ACTIONS_WITHOUT_YEAR = [
  'explore:addScenario',
  'explore:viewScenario',
  'explore:editScenario',
  'explore:archiveScenario',
];

module.exports = {
  EXPLORE_ACTIONS,
  EXPLORE_ACTIONS_WITHOUT_YEAR,
};
